import {
    useEffect,
    useRef,
} from 'react';
import {
    Navigate,
    Outlet,
    useLocation,
} from 'react-router-dom';
import { toast } from 'sonner';

import { useRbac } from '@/hooks/useRbac';
import { namespacesForPath } from '@/lib/rbac';

interface RequirePermissionProps {
    namespaces?: string[];
    redirectTo?: string;
}

function RequirePermission({
    namespaces,
    redirectTo = '/dashboard',
}: RequirePermissionProps) {
    const location = useLocation();
    const { hasAnyNamespace, rbac } = useRbac();
    const toastedRef = useRef(false);

    const required = namespaces ?? namespacesForPath(location.pathname);
    const isLoading = rbac === null;
    const granted = required.length === 0 ? true : hasAnyNamespace(required);

    useEffect(() => {
        if (!isLoading && !granted && !toastedRef.current) {
            toastedRef.current = true;
            toast.error("You don't have access to this page");
        }
    }, [isLoading, granted]);

    // Avoid kicking the user before whoami finishes hydrating the snapshot.
    if (isLoading) return <Outlet />;

    if (!granted) {
        return <Navigate to={redirectTo} replace state={{ from: location.pathname }} />;
    }

    return <Outlet />;
}

export default RequirePermission;
